module.exports = __webpack_public_path__ + "img/setIcon3.f9349c73.png";